import { TrackByFunction } from '@angular/core';
import { SearchResultCmsPageViewModel } from '@models/api.models';

export const trackByPageViewModel: TrackByFunction<SearchResultCmsPageViewModel> = (
    index: number,
    page: SearchResultCmsPageViewModel
) => page?.id ?? index;
